import React from 'react';
import {
  Typography,
  Box,
  LinearProgress
} from '@mui/material';
import { Card } from 'Components/Card'

const colorPalette = [
  '#BBDEFB', '#90CAF9', '#64B5F6',
  '#2196F3', '#1565C0', '#1A237E', '#0D1B5E'
];

const GroupedProgressCard = ({ title, data }) => {
  return (
    <Card sx={{textAlign: 'left' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle1" fontWeight="bold">{title}</Typography>
      </Box>

      {data.map((item, index) => {
        const progress = item.total > 0 ? (item.value / item.total) * 100 : 0;
        return (
          <Box key={index} mt={2}>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="body2" color="gray">{item.name}</Typography>
              <Typography variant="body2" fontWeight="bold">{item.value}</Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={progress}
              sx={{
                backgroundColor: '#EEE',
                height: 3,
                borderRadius: 2,
                '& .MuiLinearProgress-bar': {
                  backgroundColor: colorPalette[index % colorPalette.length],
                },
              }}
            />
          </Box>
        );
      })}
    </Card>
  );
};

export default GroupedProgressCard;
